<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { interactionMixin } from "src/modules/interactions_module.js";
import { kenwoodItalyAuthorizationMixin } from "../../modules/kenwood_italy_mixins_module.js";
import { KenwoodItaly } from "../../modules/kenwood_italy_module.js";
import { get } from "lodash";

export default {
  mixins: [fandomBasicMixin, interactionMixin, kenwoodItalyAuthorizationMixin],
  props: {
    trackTileClick: Array
  },
  mounted() {
    // google analytics
    if (!!this.trackTileClick){
      Vue.nextTick(() => {
        KenwoodItaly.trackLinkVisited(`#ref-${this.easyadminId}-link`, this.trackTileClick[0], this.trackTileClick[1], this.content.name);
      });
    }
  },
  methods: {
    getBackgroundUrl: Fandom.getBackgroundUrl,
    capitalize: Fandom.capitalize,
  },
  data() {
    return {
      tileHeight: 81
    };
  },
  computed: {
    miniformat() {
      return KenwoodItaly.getMiniformat(this.content);
    },
    miniformatStyle() {
      return {
        'background-color': this.miniformat.background_color || 'var(--dark)',
        'color': this.miniformat.color || '#fff'
      };
    },
    owner() {
      if (Fandom.exists(this.content.owned_by) && this.pageModel.id_to_user[this.content.owned_by]) {
        return this.pageModel.id_to_user[this.content.owned_by];
      } else {
        return this.pageModel.anonymous_user;
      }
    },
    favourite() {
      return (this.content.interactions && this.content.interactions["favourite"]) ? this.content.interactions["favourite"] : false;
    },
    share() {
      return (this.content.interactions && this.content.interactions["share"]) ? this.content.interactions["share"] : false;
    },
    like() {
      return (this.content.interactions && this.content.interactions["like"]) ? this.content.interactions["like"] : false;
    },
    isYoutubePresent() {
      const mediaType = get(this.content, ["play", "media_type"], false);
      return mediaType == "youtube";
    }
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :id="`ref-${easyadminId}`" :class="contentType" class="w-100" tile-recipe>
    <div class="tile-recipe__content d-flex flex-column">
      <div class="tile-recipe__img-wrapper bg-transition w-100">
        <a :id="`ref-${easyadminId}-link`" :href="content.slug">
          <div class="lock-label position-absolute-center d-flex align-items-center flex-column justify-content-center" v-if="!authorized">
            <svg class="lock-icon text-white" v-if="!authorized">
              <use xlink:href="#lock-icon"></use>
            </svg>
            <p class="text-uppercase text-white lock-text">{{ft("globals.register_and_log_in")}}</p>
          </div>
          <div class="tile-recipe__img-content bg w-100 lazy-bg" :lazy-src="getTileThumbnailUrl('thumbnail')" :class="{'locked': !authorized}">
            <div class="position-absolute-center d-flex align-items-center justify-content-center" v-if="isYoutubePresent">
              <svg class="play-icon text-white">
                <use xlink:href="#play-icon"></use>
              </svg>
            </div>
          </div>
        </a>
        <div class="tile-recipe__miniformat" :style="miniformatStyle" v-if="miniformat && miniformat.title">
          {{miniformat.title}}
        </div>
        <div v-if="owner" class="user-info-content d-flex border-bottom border-kenwood-gray">
          <div class="user-info-content__name align-items-center d-flex text-kenwood-dark-grey">By {{owner.username}}</div>
          <component v-if="owner.avatar" :is="owner.url ? 'a' : 'div'" :href="owner.url ? owner.url.url : null" :target="getTarget(owner.url)" class="user-info-content__avatar-container">
            <div class="user-info-content__avatar" :style="{'background-image': getBackgroundUrl(owner.avatar.url)}"></div>
          </component>
        </div>
      </div>
      <div class="tile-recipe__info-wrapper w-100">
        <div class="tile-recipe__info-content w-100 d-flex justify-content-between">
          <div class="category-wrapper flex-column d-flex justify-content-center" v-if="decorator">
            <div v-if="decorator.title" class="category-content">{{decorator.title}}</div>
          </div>
          <div class="interactions-box-wrapper d-flex justify-content-end">
            <div class="interactions-box-content d-flex align-items-center">
              <div v-if="like" class="interactions-like d-flex align-items-center">
                <span>{{getLikeCounter(containerContent, like.interaction, "")}}</span>
                <i class="px-2 fa-heart" :class="[isLikeDone(containerContent, like.interaction) ? 'fas text-red-cabbage' : 'fal']" @click="updateLikeInteraction(containerContent, like, like.interaction)"></i>
              </div>
              <div v-if="favourite" class="interactions-favourite d-flex">
                <i class="fa-bookmark px-2" :class="[isFavourite(containerContent, favourite.interaction) ? 'fas text-red-cabbage' : 'fal']" @click="openFavouriteModal(containerContent, favourite, favourite.interaction)"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tile-recipe__title-wrapper w-100">
        <div class="tile-recipe__title-content w-100">
          <p class="h6 p-0 pb-3 pb-sm-0" v-shave="{ height: tileHeight }">{{content.title}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[tile-recipe] {
  $title-height: 16%;
  padding-bottom: 120%;

  // Sum of these classes 'padding-bottom' property must be equal to 120% (because of fixed aspect-ratio)
  .tile-recipe__img-wrapper {
    padding-bottom: 67.4%;
  }

  .tile-recipe__miniformat {
    top: .5rem;
    left: .5rem;
    position: absolute;
    font-size: .875rem;
    padding: .25rem .5rem;
    text-transform: uppercase;
  }

  .tile-recipe__info-wrapper {
    padding-bottom: 16.1%;

  }
  .tile-recipe__title-wrapper {
    padding-bottom: 36.5%;
  }

  .interactions-like, .interactions-favourite {
    color: $kenwood-dark-grey;
    i {
      cursor: pointer;
      &:hover {
        color: $red-cabbage;
      }
    }
  }

  .interactions-like {
    span {
      font-size: 0.8rem;
    }
  }

  .user-info-content__name {
    font-size: 0.8125rem;
    overflow: hidden;
    position: relative;
    width: 74%;
  }

  .user-info-content__avatar-container {
    position: relative;
    width: 26%;
  }

  .user-info-content__avatar {
    background-position: center;
    background-size: cover;
    border-radius: 50%;
    bottom: 25%;
    padding-bottom: 64%;
    position: absolute;
    right: 10%;
    width: 64%;
  }

  .category-content {
    font-size: 0.75rem;
    text-transform: uppercase;
  }

  .interactions-box-content {
    font-size: 1.35rem;
  }

  .tile-recipe__content, .tile-recipe__title-content,
  .tile-recipe__info-content, .tile-recipe__img-content {
    position: absolute;
    overflow: hidden;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .tile-recipe__img-wrapper, .tile-recipe__info-wrapper,
  .tile-recipe__title-wrapper{
    position: relative;
    overflow: hidden;
  }

  .tile-recipe__img-content {
    background-size: cover;
    cursor: pointer;
    background-position: center;
    background-color: $kenwood-light-grey;
  }

  .user-info-content {
    position: absolute;
    width: 100%;
    height: $title-height;
    background-color: $white;
    bottom: 0;
    left: 0;
  }

  .play-icon {
    width: 3rem;
    height: 3rem;
    margin-bottom: $title-height / 2;
  }

  .lock-label{
    z-index: 1;

    .lock-icon {
      width: 3rem;
      height: 3rem;
      fill: currentColor;
    }

    .lock-text {
      margin-top: 15px;
      font-weight: 500;
    }
  }

  .locked {
    filter: blur(4px);
    background-color: rgba($black, .20);
    background-blend-mode: darken;
  }
  
}
</style>
